/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_End_Event_Punctuation_LabelInputs */

const en_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End event on punctuation (. ? !)`)
};

const fr_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer l'evenement sur ponctuation (. ? !)`)
};

const de_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis bei Satzzeichen beenden (. ? !)`)
};

const it_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina l'evento con la punteggiatura (. ? !)`)
};

const ru_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершение события по пунктуации (. ? !)`)
};

const es_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin del evento en puntuación (. ? !)`)
};

const zh_cn2_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以标点符号（. ? !）结束事件`)
};

const ja_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`句読点（。? !）でイベントを終了します`)
};

const hi_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विराम चिह्न (. ? !) पर समाप्ति घटना`)
};

const pt_pt2_plain_text_import_end_event_punctuation_label = /** @type {(inputs: Plain_Text_Import_End_Event_Punctuation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizar evento na pontuação (. ? !)`)
};

/**
* | output |
* | --- |
* | "End event on punctuation (. ? !)" |
*
* @param {Plain_Text_Import_End_Event_Punctuation_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_end_event_punctuation_label = /** @type {((inputs?: Plain_Text_Import_End_Event_Punctuation_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_End_Event_Punctuation_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_end_event_punctuation_label(inputs)
	if (locale === "de") return de_plain_text_import_end_event_punctuation_label(inputs)
	if (locale === "it") return it_plain_text_import_end_event_punctuation_label(inputs)
	if (locale === "ru") return ru_plain_text_import_end_event_punctuation_label(inputs)
	if (locale === "es") return es_plain_text_import_end_event_punctuation_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_end_event_punctuation_label(inputs)
	if (locale === "ja") return ja_plain_text_import_end_event_punctuation_label(inputs)
	if (locale === "hi") return hi_plain_text_import_end_event_punctuation_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_end_event_punctuation_label(inputs)
	return en_plain_text_import_end_event_punctuation_label(inputs)
});